import {Asset} from '@/views/content-studio/components/asset-table/types';
import {SelectedAsset} from '@/stores/contentStudioStore';

const VIDEO_TOKEN_DURATION_MS = 30000;

export function calculateVideoTokens(asset: SelectedAsset): number {
  return Math.ceil(asset.durationMillis / VIDEO_TOKEN_DURATION_MS);
}

export function calculateVideoTokensForAssets(assets: SelectedAsset[]): number {
  return assets.reduce((acc, asset) => acc + calculateVideoTokens(asset), 0);
}

export function mapAssetToSelectedAsset(asset: Asset): SelectedAsset {
  return {
    id: asset.id,
    isUploading: false,
    thumbnail: asset.thumbnailUrl,
    fileName: asset.name || '',
    type: 'Uploads',
    url: asset.url,
    durationMillis: asset.metadata?.durationMillis || 0,
    width: asset.metadata.width,
    height: asset.metadata.height,
  };
}
